import {
  CLEAR_HOLIDAY_STATUS,
  CREATE_HOLIDAY_FAILURE,
  CREATE_HOLIDAY_REQUEST,
  CREATE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAILURE,
  DELETE_HOLIDAY_REQUEST,
  DELETE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAILURE,
  UPDATE_HOLIDAY_REQUEST,
  UPDATE_HOLIDAY_SUCCESS,
  FETCH_HOLIDAYS_FAILURE,
  FETCH_HOLIDAYS_REQUEST,
  FETCH_HOLIDAYS_SUCCESS
} from '../actionTypes';

const sortHolidays = (holidays) =>
  [...holidays].sort((a, b) => {
    const personCompare = a.person.localeCompare(b.person, 'fi');
    if (personCompare !== 0) return personCompare;
    return new Date(a.startDate) - new Date(b.startDate);
  });

const initialState = {
  items: [],
  loading: false,
  error: null,
  success: null
};

const holidaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HOLIDAYS_REQUEST:
    case CREATE_HOLIDAY_REQUEST:
    case DELETE_HOLIDAY_REQUEST:
    case UPDATE_HOLIDAY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case FETCH_HOLIDAYS_SUCCESS:
      return {
        ...state,
        items: sortHolidays(action.payload),
        loading: false,
        error: null
      };
    case CREATE_HOLIDAY_SUCCESS:
      return {
        ...state,
        items: sortHolidays([...state.items, action.payload]),
        loading: false,
        success: 'Loma tallennettu.'
      };
    case DELETE_HOLIDAY_SUCCESS:
      return {
        ...state,
        items: state.items.filter((holiday) => holiday._id !== action.payload),
        loading: false,
        success: 'Lomamerkintä poistettu.'
      };
    case UPDATE_HOLIDAY_SUCCESS:
      return {
        ...state,
        items: sortHolidays(
          state.items.map((holiday) =>
            holiday._id === action.payload._id ? action.payload : holiday
          )
        ),
        loading: false,
        success: 'Loma päivitetty.'
      };
    case FETCH_HOLIDAYS_FAILURE:
    case CREATE_HOLIDAY_FAILURE:
    case DELETE_HOLIDAY_FAILURE:
    case UPDATE_HOLIDAY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case CLEAR_HOLIDAY_STATUS:
      return {
        ...state,
        error: null,
        success: null
      };
    default:
      return state;
  }
};

export default holidaysReducer;
